import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _Buffer___init__impl__mrnqm7(value) {
  return value;
}
function _Buffer___get_value__impl__xxr8tn($this) {
  return $this;
}
function Buffer__toString_impl_hsk2ap($this) {
  return 'Buffer(value=' + toString($this) + ')';
}
function Buffer__hashCode_impl_3ylui6($this) {
  return hashCode($this);
}
function Buffer__equals_impl_4le8fi($this, other) {
  if (!(other instanceof Buffer()))
    return false;
  var tmp0_other_with_cast = other.u3p_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor(value) {
        this.u3p_1 = value;
      }
      toString() {
        return Buffer__toString_impl_hsk2ap(this.u3p_1);
      }
      hashCode() {
        return Buffer__hashCode_impl_3ylui6(this.u3p_1);
      }
      equals(other) {
        return Buffer__equals_impl_4le8fi(this.u3p_1, other);
      }
    }
    initMetadataForClass($, 'Buffer');
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  _Buffer___init__impl__mrnqm7 as _Buffer___init__impl__mrnqm7vrqbp8zsivb0,
  Buffer__hashCode_impl_3ylui6 as Buffer__hashCode_impl_3ylui62zu79ijcbfyxv,
  _Buffer___get_value__impl__xxr8tn as _Buffer___get_value__impl__xxr8tn3ssubfc4mvc5l,
  Buffer as Buffer1b80wf381wfyu,
};
//endregion

//# sourceMappingURL=-Buffer.mjs.map
